import { Trans, useTranslation } from 'react-i18next';
import { TextListComponent } from '@myriadgenetics/mgh-types';

import './index.scss';

interface Props {
  compDef: any | TextListComponent;
}

const columnedClass = (columned = false): string => (columned ? 'text-list__list--columned' : '');

function TextList({ compDef }: Props) {
  const { t } = useTranslation();
  const comp: TextListComponent = compDef as TextListComponent;
  const { columned, contentKey, listKeys, gridView } = comp.data;

  return (
    <div className="text-list">
      {contentKey && <span className="text-list__text heading-small--semi-bold">{t(contentKey)}</span>}
      <ul className={`text-list__list ${columnedClass(columned)} ${gridView ? 'text-list__list--grid' : ''}`}>
        {listKeys.map((listKey, i) => (
          <li className="text-list__item text-large--regular" key={i}>
            {<Trans i18nKey={listKey} components={[<b />]} />}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default TextList;
